import { arredondarCentimos } from '@/components/ordens/finalizar-os-logic';
import type { StatusOrdemServico } from '@/types/ordemServico';

/** Incremento de um serviço por_hora pelo tempo decorrido (arredondado a cêntimos). */
export function incrementoPorHoraLive(taxa: number, minutosDecorridos: number): number {
  return arredondarCentimos((Math.max(0, minutosDecorridos) / 60) * taxa);
}

/**
 * Valor de UM item ao vivo, por estado.
 * Não-por_hora → valorPersistido. por_hora: pendente/aceita → 0;
 * em_execucao → incremento; concluida/cancelada/recusada → valorPersistido.
 */
export function valorItemLive(params: {
  status: StatusOrdemServico;
  tipoPreco: string | null | undefined;
  taxa: number;
  valorPersistido: number;
  minutosDecorridos: number;
}): number {
  const { status, tipoPreco, taxa, valorPersistido, minutosDecorridos } = params;
  if (tipoPreco !== 'por_hora') return valorPersistido;
  if (status === 'em_execucao') return incrementoPorHoraLive(taxa, minutosDecorridos);
  if (status === 'concluida' || status === 'cancelada' || status === 'recusada') return valorPersistido;
  return 0;
}

/**
 * Total da OS ao vivo (para cards). `valorTotalPersistido` já exclui por_hora na
 * criação (0) e inclui-o quando concluída. Só em `em_execucao` se soma o
 * incremento por_hora ao vivo.
 */
export function valorOSLive(params: {
  status: StatusOrdemServico;
  valorTotalPersistido: number;
  taxaPorHoraTotal: number;
  minutosDecorridos: number;
}): number {
  const { status, valorTotalPersistido, taxaPorHoraTotal, minutosDecorridos } = params;
  if (status === 'em_execucao' && taxaPorHoraTotal > 0) {
    return arredondarCentimos(valorTotalPersistido + incrementoPorHoraLive(taxaPorHoraTotal, minutosDecorridos));
  }
  return valorTotalPersistido;
}
